// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { MasterReferenceDataResponse } from './master-reference-data-response';

// @ts-ignore
import { PracticeLocationSummaryResponse } from './practice-location-summary-response';

/** See com.rev360.pms.api.controller.patient.immunization.PatientVaccinationListResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientVaccinationListResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	administeredAmount!: number | null;

	@GandalfProperty({ designType: MasterReferenceDataResponse })
	administeredAmountUnit!: MasterReferenceDataResponse | null;

	@GandalfProperty({ designType: PracticeLocationSummaryResponse })
	administeredAtLocation!: PracticeLocationSummaryResponse | null;

	@GandalfProperty({ designType: Date })
	administeredOn!: Date | null;

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: String })
	cvxDetailCode!: string | null;

	@GandalfProperty({ designType: String })
	cvxDetailShortName!: string | null;

	@GandalfConstantDecorator(constants.VaccinationStatus)
	@GandalfProperty({ designType: constants.VaccinationStatus })
	status!: constants.VaccinationStatus | null;

	@GandalfProperty({ designType: Number })
	vaccinationId!: number | null;

}
